import { List } from "antd";

import { BaseListItemProps } from "./types";

const BaseListItem = ({ children, ...props }: BaseListItemProps) => {
  return <List.Item {...props}>{children}</List.Item>;
};

export default BaseListItem;
